export default __webpack_public_path__ + "4bfdd744dc3b043bfeea18e8c8f6879b.png";